<app-navigation class="pcoded-navbar menupos-fixed menu-light" [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'mob-open': navCollapsedMob
  }" (NavCollapsedMob)="navMobClick()">
</app-navigation>
<app-nav-bar [ngClass]="{
  'navbar-collapsed': navCollapsed
}" class="navbar pcoded-header navbar-expand-lg header headerPos-fixed navbar-primary-bg"
  (NavCollapse)="this.navCollapsed = !this.navCollapsed" (NavCollapsedMob)="navMobClick()"></app-nav-bar>
<div class="pcoded-main-container">
  <div class="pcoded-wrapper">
    <div class="pcoded-content">
      <div class="pcoded-inner-content">
        <div class="main-body">
          <div class="page-wrapper">
            <app-breadcrumb></app-breadcrumb>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-configuration></app-configuration>